/**
 * Created by comoon on 2/27/16.
 */


var expert = {
    code: 1,
    name: "达人"
};

var helper = {
    code: 2,
    name: "小帮手"
};

var other = {
    code: 0,
    name: "其他"
}

module.exports = {
    expert,
    helper,
    other,
    list: [expert, helper, other]
};


/** WEBPACK FOOTER **
 ** ./script/conf/role-type.js
 **/